export default {
  okText: '确认',
  closeText: '关闭',
  cancelText: '取消',
  loadingText: '加载中...',
  saveText: '保存',
  delText: '删除',
  resetText: '重置',
  searchText: '搜索',
  queryText: '查询',

  inputText: '请输入',
  chooseText: '请选择',

  redo: '刷新',
  back: '返回',

  light: '亮色主题',
  dark: '黑暗主题',
};
